import styled from "styled-components";

export const ControllerTournamentInfoWrapper = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
  max-width: 1587px;
  min-width: 0;
`;

export const ControllerTournamentInfoBoxWrapper = styled.div<{
  flex?: number;
}>`
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: ${(p) => p.flex};
`;

export const ControllerTournamentInputWrapper = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 20px;
  align-items: center;

  > .button {
    background: #3052fb;
    width: max-content;
    padding: 0 20px;
    height: 64px;
    border-radius: 20px;
    font-family: Pretendard;
    font-weight: 700;
    font-size: 18px;
    line-height: 64px;
    text-align: center;
    color: #fff;
    cursor: pointer;
  }

  > img {
    cursor: pointer;
  }

  > .level {
    width: 100%;
    height: 64px;
    border-radius: 20px;
    background: #fff;
    font-family: Pretendard;
    font-weight: 600;
    font-size: 20px;
    line-height: 64px;
    color: #121212;
    text-align: center;
  }
`;

export const ControllerTournamentInfoNotice = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-top: 20px;
  height: calc(100% - 78px);

  > .button {
    background: #3052fb;
    width: 100%;
    height: 58px;
    border-radius: 20px;
    font-family: Pretendard;
    font-weight: 700;
    font-size: 18px;
    line-height: 58px;
    text-align: center;
    color: #fff;
    cursor: pointer;
  }
`;

export const ControllerTournamentSoundWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 20px;
`;

export const ControllerTournamentSoundItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  > .name {
    font-family: Pretendard;
    font-weight: 600;
    font-size: 20px;
    color: #c6c6c6;
  }
`;

export const ControllerTournamentToggleItem = styled.div<{
  isOn: boolean;
}>`
  position: relative;
  cursor: pointer;
  width: 71px;
  height: 30px;
  background: ${(p) => (p.isOn ? "#3052FB" : "#2E2E2E")};
  border-radius: 100px;
  transition: background 0.3s ease-in-out;
`;

export const ControllerTournamentToggleCircle = styled.div<{
  isOn: boolean;
}>`
  position: absolute;
  top: 3px;
  left: ${(p) => (p.isOn ? "42px" : "4px")};
  width: 25px;
  height: 25px;
  background: #fff;
  border-radius: 50%;
  transition: left 0.3s ease-in-out;
`;

export const ControllerTournamentBlindWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: -2px;
`;

export const BlindUpSelect = styled.div<{ isSelected: boolean }>`
  width: 100px;
  height: 45px;
  border-radius: 20px;
  cursor: pointer;
  font-family: Pretendard;
  font-weight: 500;
  font-size: 14px;
  line-height: 45px;
  text-align: center;
  background: ${(p) => (p.isSelected ? "#3052FB" : "none")};
  color: ${(p) => (p.isSelected ? "#fff" : "#969696")};
`;

export const ControllerTimerCircle = styled.svg`
  width: 380px;
  height: 380px;
  overflow: visible;

  circle {
    cursor: pointer;
    fill: none;
    pointer-events: stroke;
    stroke-width: 20;
    stroke-linecap: round;
  }

  .background {
    stroke: #f0f0f033;
  }

  .progress {
    pointer-events: stroke;
    transform-origin: center;
    transition: stroke-dashoffset 0.35s ease;
  }
`;

export const ControllerTournamentCircleWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 17px;
  align-items: flex-end;
  position: relative;
  margin-top: 9px;
`;

export const ControllerTournamentCircleTextWrapper = styled.div`
  position: absolute;
  top: 55%;
  transform: translateY(-55%);

  > .title {
    font-family: Pretendard;
    font-weight: 500;
    font-size: 30px;
    text-align: center;
    color: #ffffff;
  }

  > .time {
    font-family: Pretendard;
    font-weight: 600;
    font-size: 100px;
    text-align: center;
    color: #ffffff;
  }
`;

export const ControllerTournamentCircleButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 10px;

  > .button {
    cursor: pointer;
    width: 68px;
    height: 68px;
    border-radius: 50%;
    background: #626262;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  > .name {
    font-family: Pretendard;
    font-weight: 700;
    font-size: 18px;
    text-align: center;
    color: #ffffff;
  }
`;

export const ControllerTournamentTimeUpdateWrapper = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
  margin-top: 20px;
`;

export const ControllerTournamentTimeButtonWrapper = styled.div<{
  isPlus: boolean;
  isWide: boolean;
}>`
  display: flex;
  gap: 6px;
  flex-direction: column;

  > .box {
    width: ${(p) => (p.isWide ? "110px" : "55.42px")};
    height: ${(p) => (p.isWide ? "58px" : "29.22px")};
    border-radius: ${(p) => (p.isWide ? "20px" : "10.08px")};
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }

  .button {
    width: ${(p) => (p.isWide ? "98px" : "49.38px")};
    height: ${(p) => (p.isWide ? "46px" : "23.18px")};
    border-radius: ${(p) => (p.isWide ? "20px" : "10.08px")};
    font-family: Pretendard;
    font-weight: 700;
    font-size: ${(p) => (p.isWide ? "18px" : "9.07px")};
    line-height: ${(p) => (p.isWide ? "46px" : "23px")};
    text-align: center;
    color: #fff;
  }

  > .second-box {
    background: ${(p) => (p.isPlus ? "#263fbf80" : "#A90B1080")};

    > .button {
      background: ${(p) => (p.isPlus ? "#263fbf" : "#A90B10")};
    }
  }

  > .minute-box {
    background: ${(p) => (p.isPlus ? "#3052fb80" : "#DD0C1280")};

    > .button {
      background: ${(p) => (p.isPlus ? "#3052fb" : "#DD0C12")};
    }
  }
`;

export const ControllerTournamentTimeUpdate = styled.div`
  width: 100%;
  height: 100%;
  padding: 24px 20px;
  box-sizing: border-box;

  > .name {
    font-family: Pretendard;
    font-weight: 500;
    font-size: 18px;
    color: #fff;
  }

  > .wrapper {
    margin-top: 12px;
    display: flex;
    gap: 8px;

    > .box {
      height: 44px;
      border-radius: 20px;
      font-family: Pretendard;
      font-weight: 700;
      font-size: 18px;
      line-height: 38px;
      text-align: center;
      cursor: pointer;
      box-sizing: border-box;
      color: #fff;
    }

    > .plus-box {
      width: 70.5px;
      border: 3px solid #2f4094;
      background: #3052fb;
    }

    > .minus-box {
      width: 70.5px;
      border: 3px solid #851d20;
      background: #dd0c12;
    }

    > input {
      height: 44px;
      border-radius: 20px;
      font-family: Pretendard;
      font-weight: 500;
      font-size: 18px;
      line-height: 38px;
      text-align: center;
      width: 149px;
      outline: none;
      border: none;
      font-family: Pretendard;
      font-weight: 500;
    }
  }
`;
